import {
  RedCardIcon,
  OffTargetVariant2Icon,
  OnTargetVariant2Icon,
  YellowCardIcon,
} from '@/common/assets';

import { PlayerStatsOptionValues } from '../../constants';
import type { PlayerStatsOption } from '../../types';

interface PlayersStatsHeaderProps {
  activeFilter: PlayerStatsOption;
}

export default function PlayersStatsHeader({ activeFilter }: PlayersStatsHeaderProps) {
  switch (activeFilter) {
    case PlayerStatsOptionValues.SHOTS:
      return (
        <div className="col-span-5 grid grid-cols-subgrid justify-items-center text-pmw-if-secondary-light dark:text-pmw-if-secondary-dark">
          <OffTargetVariant2Icon className="col-start-[stat-1]" />
          <OnTargetVariant2Icon className="col-start-[stat-2]" />
        </div>
      );
    case PlayerStatsOptionValues.CARDS:
      return (
        <div className="col-span-5 grid grid-cols-subgrid items-center justify-items-center h-[16px]">
          <YellowCardIcon className="col-start-[stat-1] h-[12px]" />
          <RedCardIcon className="col-start-[stat-2] h-[12px]" />
        </div>
      );
    default:
      return null;
  }
}
